import React from 'react';
import TU from '../tu';

export default class SeatwaveHeader extends React.Component {
  static propTypes = {
    header: React.PropTypes.string,
    text: React.PropTypes.string,
    isDisabled: React.PropTypes.bool
  };

  render () {
    const headerClass = this.props.isDisabled
    ? 'ticket_stub_cell__header is-disabled' : 'ticket_stub_cell__header';

    return (
      <div className="ticket_stub_header--seatwave">
        <div className="ticket_stub_header--seatwave_status">
          <div className={headerClass}>{this.props.header}</div>
          <div className="ticket_stub_cell__text">
            <TU text={this.props.text} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/seatwave_header.js